// src/components/atoms/PlantAnimation/index.jsx
import React from "react";
import Lottie from "react-lottie";
import snakePlantAnimation from "../../lottie-files/SnakePlant.json";

const SNAKE_PLANT_HEIGHT = 34;
const SNAKE_PLANT_WIDTH = 30;
const SNAKE_PLANT_URL = "https://www.ugaoo.com/collections/snake-plant";

const createAnimationOptions = (animationData) => ({
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid meet",
  },
});

const renderPlant = ({ animationData, height, width }) => (
  <Lottie
    options={createAnimationOptions(animationData)}
    height={height}
    width={width}
    isClickToPauseDisabled={true}
  />
);

const PlantAnimation = () => {
  return (
    <a
      aria-label="Open snake plant collection"
      className="inline-block align-middle"
      href={SNAKE_PLANT_URL}
      rel="noreferrer"
      target="_blank"
    >
      {renderPlant({
        animationData: snakePlantAnimation,
        height: SNAKE_PLANT_HEIGHT,
        width: SNAKE_PLANT_WIDTH,
      })}
    </a>
  );
};

export default PlantAnimation;
